import { Reducer } from 'redux';

import { ListsState } from './types';

const defaultState: ListsState = {
    isListLoading: false,
    isListNamesLoading: false,
    listFromCampaignLoading: false,
    collection: null,
    visibleSet: null,
    historyTrackedCollection: null,
    isNthListCreated: false,
    newList: {
        ListName: 'New list',
        Count: 1,
        ExcludeBlocked: false,
        AllowUnsubscribe: false,
        Rule: '',
        CreateEmptyList: false,
    },
};

const reducer: Reducer<ListsState> = (state = defaultState, action): ListsState => {
    const { type, payload } = action;
    switch (type) {
        case '@@lists/FETCH_START':
        case '@@lists/SINGLE_FETCH_START':
            return { ...state, isListLoading: true };
        case '@@lists/CREATE_NTH_START':
            return { ...state, isNthListCreated: true };
        case '@@lists/CREATE_NTH_ERROR':
            return { ...state, isNthListCreated: false };
        case '@@lists/CREATE_NTH_SUCCESS':
            return { ...state, isNthListCreated: false };
        case '@@lists/EDIT_SUCCESS':
            return {
                ...state,
                collection: payload.collection,
            };
        case '@@lists/FETCH_LISTNAMES_START':
            return {
                ...state,
                isListNamesLoading: true,
            };
        case '@@lists/FETCH_LISTNAMES_ERROR':
            return {
                ...state,
                isListNamesLoading: false,
            };
        case '@@lists/FETCH_LISTNAMES_SUCCESS':
            return {
                ...state,
                listNamesCollection: payload.listNamesCollection,
                isListNamesLoading: false,
            };

        case '@@lists/FETCH_SUCCESS':
            return {
                ...state,
                totalCount: payload.totalCount,
                collection: payload.collection,
                totalTrackedLists: payload.totalTrackedLists,
                isListLoading: payload.isListLoading,
            };
        case '@@lists/FETCH_ERROR':
        case '@@lists/SINGLE_FETCH_SUCCESS':
        case '@@lists/CREATE_RANDOM_SUCCESS':
        case '@@lists/CREATE_NEW_PARAMS':
        case '@@lists/ADD_SUCCESS':
        case '@@lists/DELETE_SUCCESS':
        case '@@lists/SET_NEW_PARAMS':
        case '@@lists/SELECT':
        case '@@lists/DESELECT':
        case '@@lists/SET_COLLECTION':
            return { ...state, ...action.payload };
        case '@@lists/LOAD_HISTORY_TRACKED_START':
        case '@@lists/LOAD_HISTORY_TRACKED_ERROR':
            return { ...state, ...action.payload.isListLoading };
        case '@@lists/LOAD_HISTORY_TRACKED_SUCCESS':
        case '@@lists/LOAD_BY_CONTACT_SUCCESS':
            return { ...state, ...action.payload };
        case '@@lists/LIST_FROM_CAMPAIGN_START':
            return { ...state, listFromCampaignLoading: true };
        case '@@lists/LIST_FROM_CAMPAIGN_SUCCESS':
        case '@@lists/LIST_FROM_CAMPAIGN_ERROR':
            return { ...state, listFromCampaignLoading: false };
        case '@@lists/DELETE_START':
        case '@@lists/REMOVE_CONTACTS_START':
        default:
            return state;
    }
};

export { reducer as lists };

export default reducer;
